var _path, _g, _path2, _path3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1607",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 13,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.60107H15.0337V17.7873H3V4.60107Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1607)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2305 6.11133C11.3645 6.11133 10.2515 7.02733 9.32551 7.78933C8.43551 8.52133 7.73351 9.09933 7.02851 9.15533C6.71351 9.17933 6.44351 9.19033 6.20551 9.19933C5.46651 9.22633 5.27951 9.24433 4.94751 9.52833C4.49451 9.91533 4.49851 11.4633 4.50051 12.3873L4.50151 12.6333L4.50051 12.8803C4.49851 13.8043 4.49451 15.3523 4.94751 15.7393C5.28651 16.0293 5.47851 16.0473 6.23551 16.0733C6.46451 16.0813 6.72351 16.0903 7.02251 16.1113C7.10851 16.1173 7.19651 16.1313 7.28651 16.1533L13.5245 9.91533C13.4515 7.69033 13.2265 6.69233 12.6965 6.21833C12.5525 6.14433 12.3965 6.11133 12.2305 6.11133ZM7.46351 17.7873C7.33451 17.7873 7.20551 17.7543 7.08851 17.6863C6.96851 17.6173 6.91351 17.6073 6.91351 17.6073C6.63751 17.5883 6.39751 17.5793 6.18351 17.5723C5.36751 17.5443 4.72251 17.5213 3.97251 16.8803C2.99251 16.0423 2.99651 14.2873 3.00051 12.8763L3.00151 12.6333L3.00051 12.3913C2.99651 10.9803 2.99251 9.22433 3.97351 8.38733C4.71351 7.75433 5.34751 7.73033 6.14851 7.70033C6.36951 7.69133 6.61851 7.68233 6.91051 7.65933C7.16151 7.62733 7.89051 7.02733 8.37251 6.63133C9.77851 5.47233 11.7055 3.88633 13.5075 4.95433C13.5405 4.97233 13.5715 4.99433 13.6005 5.01833C14.7245 5.93333 14.9645 7.48133 15.0335 10.1983C15.0385 10.4033 14.9595 10.6013 14.8135 10.7473L7.99451 17.5673C7.84951 17.7123 7.65751 17.7873 7.46351 17.7873Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.233 20.666C11.223 20.666 10.264 20.081 9.55303 19.566C9.21703 19.324 9.14203 18.855 9.38403 18.52C9.62803 18.184 10.097 18.107 10.432 18.352C11.745 19.301 12.337 19.238 12.696 19.05C13.278 18.531 13.499 17.363 13.533 14.657C13.539 14.243 13.842 13.921 14.293 13.917C14.707 13.923 15.039 14.263 15.033 14.677C14.995 17.632 14.763 19.305 13.6 20.25C13.57 20.273 13.54 20.295 13.508 20.313C13.084 20.564 12.654 20.666 12.233 20.666Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_67_1607",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 18,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00195 4.00024H20.5002V21.5H3.00195V4.00024Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_67_1607)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7517 21.5C3.5597 21.5 3.3677 21.427 3.2217 21.28C2.9287 20.987 2.9287 20.513 3.2217 20.22L19.2207 4.21999C19.5137 3.92699 19.9877 3.92699 20.2807 4.21999C20.5737 4.51299 20.5737 4.98699 20.2807 5.27999L4.2817 21.28C4.1357 21.427 3.9437 21.5 3.7517 21.5Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOff);
export default __webpack_public_path__ + "static/media/VolumeOff.423a8b17765fa013ba9dd3c4422ab0f1.svg";
export { ForwardRef as ReactComponent };